import React, { useEffect } from "react";
import "@styles/pages/Redeem/Redeem.scss";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import RedeemSection from "@pages/Redeem/step1/RedeemSection";
import RedeemPage from "@pages/Redeem/step2/RedeemPage";
import RedeemSamsungRewardPage from "@pages/Redeem/step2/RedeemSamsungRewardPage";
import ThankYouPage from "@pages/GenericPage/ThankYouPage";
import useScrollToTop from "@hooks/useScrollToTop";
import { resetFormStep } from "@store/ui/formStepSlice";
import { useTranslation } from "react-i18next";
import { useLocation, Navigate } from "react-router-dom";

const Redeem = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();

  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );
  const isLoggedIn = !!memberInfoData;

  const currentStep = useSelector((state) => state.formStep.redeem);

  useScrollToTop();

  useEffect(() => {
    dispatch(resetFormStep({ formKey: "redeem" }));
  }, [dispatch]);

  // ❗守衛：Step 1–4 需要登入，否則跳去 /login
  const isProtectedStep = currentStep >= 1 && currentStep <= 4;
  if (isProtectedStep && !isLoggedIn) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return (
    <Box className="redeem-container">
      {currentStep === 0 && <RedeemSection />}
      {currentStep === 1 && <RedeemPage />}

      {currentStep === 2 && (
        <ThankYouPage
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("redeem:thank_you_message_title"),
              }}
            ></span>
          }
          textList={[
            <span
              dangerouslySetInnerHTML={{
                __html: t("redeem:thank_you_message_description"),
              }}
            ></span>,
          ]}
        />
      )}
      {currentStep === 3 && <RedeemSamsungRewardPage />}
      {currentStep === 4 && (
        <ThankYouPage
          title={<span
            dangerouslySetInnerHTML={{
              __html: t("redeem:samsung_reward_thank_you_message_title"),
            }}
          ></span>}
          textList={[<span
            dangerouslySetInnerHTML={{
              __html: t("redeem:samsung_reward_thank_you_message_description"),
            }}
          ></span>]}
        />
      )}

      {/* 可選：fallback，避免未知 step */}
      {currentStep < 0 && <RedeemSection />}
    </Box>
  );
};

export default Redeem;
